import React from 'react';
import { motion } from 'framer-motion';
export function Pricing() {
  const scrollToForm = () => {
    document.getElementById('lead-form')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-12 lg:py-32 bg-brand-darker" data-id="element-170">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-171">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} data-id="element-172">
          <h2 className="text-2xl md:text-4xl lg:text-5xl font-light text-white mb-4 lg:mb-6 tracking-tight" data-id="element-173">
            Premium care, predictable pricing
          </h2>
          <p className="text-base lg:text-lg text-brand-muted mb-8 lg:mb-16 max-w-2xl mx-auto font-light" data-id="element-174">
            Quality dental care shouldn't be complicated. The VIP Plan makes
            preventive care accessible for individuals and families.
          </p>

          <div className="bg-brand-card rounded-2xl lg:rounded-[2.5rem] border border-brand-border p-6 md:p-16" data-id="element-175">
            <div className="flex flex-col items-center justify-center mb-6 lg:mb-10" data-id="element-176">
              <span className="text-brand-muted font-medium uppercase tracking-widest text-xs mb-4 lg:mb-6" data-id="element-177">
                Annual Membership
              </span>
              <div className="flex items-baseline justify-center text-white mb-4 lg:mb-6" data-id="element-178">
                <span className="text-5xl md:text-8xl font-light tracking-tighter" data-id="element-179">
                  $500
                </span>
                <span className="text-xl md:text-2xl text-brand-muted ml-3 font-light" data-id="element-180">
                  /year
                </span>
              </div>
              <div className="inline-block border border-brand-border text-brand-muted px-5 py-2 rounded-full text-sm font-light" data-id="element-181">
                Or $50/month — flexible payments available
              </div>
            </div>

            <div className="max-w-md mx-auto mb-8 lg:mb-12" data-id="element-182">
              <p className="text-brand-muted font-light leading-relaxed" data-id="element-183">
                Ideal for uninsured adults, underinsured families,
                cost-conscious patients, and anyone who delays care due to price
                uncertainty.
              </p>
            </div>

            <button onClick={scrollToForm} className="bg-white hover:bg-white/90 text-brand-dark font-medium py-3 lg:py-4 px-10 lg:px-12 rounded-full transition-all text-base lg:text-lg" data-id="element-184">
              Join the VIP Plan
            </button>
          </div>
        </motion.div>
      </div>
    </section>;
}